/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendearly2Inputs */

const en_actionendearly2 = /** @type {(inputs: Actionendearly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End early`)
};

const de_actionendearly2 = /** @type {(inputs: Actionendearly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorzeitig beenden`)
};

/**
* | output |
* | --- |
* | "End early" |
*
* @param {Actionendearly2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendearly2 = /** @type {((inputs?: Actionendearly2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendearly2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendearly2(inputs)
	return de_actionendearly2(inputs)
});
export { actionendearly2 as "actionEndEarly" }